import { Line, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { BEAM_TOP_OFFSET, SERIF } from "../../constants";
import { useSettings } from "../../hooks/useSettings";
import { useStoreRoom, useStoreSystem } from "../../store";

export const TotalDimensionRoomHorizontal = () => {
    const groupRef = useRef<any>(null);
    const ref = useRef<any>(null);
    const textRef = useRef<any>(null);

    useFrame(() => {
        const roomHeight = useStoreRoom.getState().height;
        const roomLength = useStoreRoom.getState().length;
        const roomDepth = useStoreRoom.getState().depth;
        const currentSide = useStoreSystem.getState().currentSide;

        const width = ["left", "right"].includes(currentSide) ? roomDepth : roomLength;
        if (groupRef.current) {
            groupRef.current.scale.x = width / 1000;
            groupRef.current.position.x = -width / 2000;
            groupRef.current.position.y = (roomHeight - BEAM_TOP_OFFSET) / 1000;
            groupRef.current.position.z = 0.1;
            textRef.current.position.y = (roomHeight - BEAM_TOP_OFFSET * 3) / 1000;
            textRef.current.text = width;
            textRef.current.position.z = 0.1;
        }
    });

    const { isVisibleSizes } = useSettings();
    if (!isVisibleSizes) {
        return null;
    }

    return (
        <group>
            <group renderOrder={10} ref={groupRef}>
                <Line
                    ref={ref}
                    points={[
                        [0, 0, 0],
                        [1, 0, 0],
                    ]}
                    lineWidth={2}
                    color="white"
                />
                <Line
                    points={[
                        [0, -SERIF, 0],
                        [0, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
                <Line
                    points={[
                        [1, -SERIF, 0],
                        [1, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
            </group>
            <Text ref={textRef} color="white" anchorX="center" anchorY="middle">
                {" "}
            </Text>
        </group>
    );
};
